export { default } from "./TabScrollButton.js";
export { default as tabScrollButtonClasses } from "./tabScrollButtonClasses.js";
export * from "./tabScrollButtonClasses.js";